import { useEffect, useState } from "react";
import { useInView, useMotionValue, useSpring, animate } from "framer-motion";
import { useRef } from "react";

export const Counter = ({ to = 100, suffix = "", duration = 1.6, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration,
      ease: "easeOut",
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to, duration]);

  return (
    <span ref={ref} className={className} data-testid={`counter-${to}`}>
      {display}
      {suffix}
    </span>
  );
};

export default Counter;
